import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const useToolsStyles = createUseStyles({
  toolsWrapper: {
    display: 'flex',
    margin: '2rem 0',
    '& > *': {
      marginRight: '0.75rem'
    }
  }
})

const useFilterStyles = createUseStyles({
  tableFilterWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    '& > button[data-btn=add]': {
      padding: '15px 5px',
      fontSize: 12,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      color: colors.primary1,
      '&:focus': {
        border: 0,
        outline: 0
      }
    }
  },
  tableFilterTooltipContainer: {
    position: 'absolute',
    top: 40,
    left: 0,
    minWidth: 250,
    backgroundColor: '#fff',
    zIndex: 999,
    borderRadius: 4,
    boxShadow: '1px 1px 15px -5px rgba(0,0,0,0.18)'
  },
  tableFilterTooltipHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 15,
    color: '#999',
    fontSize: 14,
    borderBottom: '1px solid #ddd',
    '& > i[data-icon=close]': {
      cursor: 'pointer'
    }
  },
  tableFilterTooltipContent: {
    padding: 15
  },
  tableFilterTagsContainer: {
    display: 'flex'
  }
})

const tagAction = {
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  '& > i': {
    marginTop: -1
  },
  '&:not(:last-child)': {
    borderRight: '1px solid #ddd'
  },
  '&:hover': {
    backgroundColor: '#f7f7f7'
  }
}

const useTagStyles = createUseStyles({
  tagWrapper: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 12,
    minWidth: 120,
    padding: '5px 10px',
    color: '#000',
    fontSize: 12,
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: 16
  },
  tagValue: {
    '&.disabled': {
      textDecoration: 'line-through',
      opacity: '0.4'
    }
  },
  tagOverlay: {
    display: 'flex',
    opacity: 0,
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 9999,
    backgroundColor: '#fff',
    borderRadius: 16,
    transition: 'all 0.2s ease-in-out',
    cursor: 'pointer',
    '&:hover': {
      opacity: '1 !important'
    },
    '& > span[data-tag=edit]': {
      ...tagAction,
      flex: 1,
      borderBottomLeftRadius: 16,
      borderTopLeftRadius: 16
    },
    '& > span[data-tag=toggle-disabled]': {
      ...tagAction,
      width: '2.5rem',
      '&.disabled': {
        color: 'orange'
      }
    },
    '& > span[data-tag=remove]': {
      ...tagAction,
      width: '2.5rem',
      color: '#ff1c24',
      borderTopRightRadius: 16,
      borderBottomRightRadius: 16
    }
  }
})

const useFilterTooltipStyles = createUseStyles({
  filterTooltipValueContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    margin: '1rem 0',
    '& > *:first-child': {
      marginRight: '1rem'
    }
  }
})

export { useToolsStyles, useFilterStyles, useFilterTooltipStyles, useTagStyles }
